import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/rem'
import './styles/index.less'
import { Dialog, Toast, Overlay } from 'vant'
Vue.config.productionTip = false
Vue.prototype.$dialog = Dialog
Vue.prototype.$toast = Toast
if (process.env.NODE_ENV != 'production') {
  const VConsole = require('vconsole')
  new VConsole()
}
Vue.use(Overlay)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
